import swal from 'sweetalert';

export const confirmationModal = (obj) => {
    swal({
        title: obj.title,
        text: obj.text,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#DD6B55',
        confirmButtonText: 'Aceptar',
        cancelButtonText: 'Cancelar',
        closeOnConfirm: true,
        closeOnCancel: true,
    }, (isConfirm) => {
        if (isConfirm) {
            obj.function();
        }
    });
}

export const calcularEdad = (fecha)=>{
    var hoy = new Date();
    var cumpleanos = new Date(fecha.split(/\//).reverse().join('/'));
    
    if(cumpleanos.toString() !== 'Invalid Date'){
        var edad = hoy.getFullYear() - cumpleanos.getFullYear();
        var m = hoy.getMonth() - cumpleanos.getMonth();

        if (m < 0 || (m === 0 && hoy.getDate() < cumpleanos.getDate())) {
            edad--;
        }
        if(edad >= 0 && edad < 110){
            return edad;
        }

        return 0;
    }

    return 0;

}
export const getFormatHour = (hr)=>{
    var format = hr.split(' ');
    var hrs    = format[0].split(':');
    var ampm = format.length === 2 ? format[1] : format[1]+' '+format[2];
    var hour = parseInt(hrs[0],10);
    var minute = parseInt(hrs[1],10);
    
    if((ampm === "PM" || ampm === "p. m.") && hour < 12)	hour += 12;

    if((ampm === "AM" || ampm === "a. m.") && hour === 12)	hour -= 12;

    if(hour < 10) hour = '0'+hour;

    if(minute < 10) minute = '0'+minute;
    var nvaHour = hour+':'+minute;

    return nvaHour;
}

export const isValidaDate = (fecha)=>{
    if(fecha.indexOf('_') === -1){
        var arr = fecha.toString().split("/");
        for(var i=0; i< arr.length;i++){
            if (!/^([0-9])*$/.test(arr[i]))
                return false;
        }
    
        var fecha_aux = new Date(fecha.split(/\//).reverse().join('/'));
        if(fecha_aux.toString() === 'Invalid Date')
            return false;

        return true;
    }else{
        return false;
    }
}

export const isValidForm = (element)=>{
	var ctrls = [];
	const select = document.querySelector(element);

	if(select !== null){
		ctrls = select.querySelectorAll('input, select');
   	
	    let isFormValid = true;
    	 ctrls.forEach(ctrl => {
	    	if(ctrl.required){
		      	const isInputValid = showCtrlError(ctrl.id);
		      	if (!isInputValid) {
		        	isFormValid = false;
		    	}
		  	}
	    });
	   
	    return isFormValid;
	}

	return true;
};

export const showCtrlError = (id)=>{
	var res = null;
	var control = document.getElementById(id);

	if(control !== null){
		if (control.value.trim() === "") {
	        if(control !== null){
	            control.classList.add('error');
	        }
			res = false;
		} else{
			if(control !== null){
				if(control.required && control.className.includes('error')){
		        	control.classList.remove('error');
		    	}
	    	}
			res = true;
		}
	}

	return res;
};

export const validString = (value, name)=>{
    if(name === 'patient'){
        return new RegExp("^[a-zA-Záéíóú´ ()ñÑ]+$").test(value);
    }else{
        return new RegExp("^[a-zA-Záéíóú´ ./ñÑ]+$").test(value);
    }
}


export const transformOptionsById = (response)=>{
    return response.map((res)=>{
        var obj = {
            value:res.id,
            text:res.name
        };

        return obj;
    });
};

export const transformOptionsByKey = (response)=>{
    return response.map((res)=>{
        var obj = {
            value:res.key,
            text:res.name
        };

        return obj;
    });
};

export const showErrors = (errors)=>{
    var msg = "<div class='col-xs-12'>";
    msg += "<h4>Se encontraron algunos errores</h4>";
    msg += "<div class='col-xs-12'><ul>";
    for(var i =0;i < errors.length;i++){
        msg+="<li style='color:red;text-align:left;'>"+errors[i]+"</li>";
    }
    msg += '</ul></div></div>';

    swal({
        title: 'Error',
        html:true,
        text: msg,
        type: 'error'
    });
}